// if (process.env.NODE_ENV === 'production') {
//     var console = {}
//     console.log = function () {
//     }
//     console.error = function () {
//     }
//     console.trace = function () {
//     }
//     console.warn = function () {}
//     window.console = console
// }

import 'babel-polyfill'

// Plugins
import '@/plugins'

import * as Sentry from "@sentry/browser"
import { Integrations } from "@sentry/tracing"

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: "https://78a15a6e94154170a8dbc213e7b83bbb@o446442.ingest.sentry.io/4504560560046080",
        integrations: [new Integrations.BrowserTracing()],
        environment: process.env.NODE_ENV,
        release : process.env.MIX_VERSION,

        // 100% of errors
        sampleRate : 1.0,

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.5 : 0,
        replaysOnErrorSampleRate: 1.0
    })
}

// Start: Aria Label Automatic Accessibility Enhancement
const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1) { // Element node
                    // Check for inputs and textareas
                    if (node.tagName === 'INPUT' || node.tagName === 'TEXTAREA') {
                        addAriaLabel(node);
                    }
                    // Check child inputs and textareas
                    node.querySelectorAll('input, textarea').forEach(addAriaLabel);
                    
                    // Check for links and buttons
                    if (node.tagName === 'A' || node.tagName === 'BUTTON') {
                        addAriaLabelToLinkOrButton(node);
                    }
                    // Check child links and buttons
                    node.querySelectorAll('a, button').forEach(addAriaLabelToLinkOrButton);
                }
            });
        }
    });
});

function addAriaLabel(input) {
    // Only skip if aria-label exists AND is not empty
    if (input.hasAttribute("aria-label") && input.getAttribute("aria-label").trim() !== "") {
        return;
    }
    
    let ariaLabel = "";
    const typeLabels = {
        'checkbox': 'checkbox option',
        'radio': 'radio option',
        'submit': 'submit button',
        'reset': 'reset button',
        'file': 'file upload field',
        'password': 'password field',   
        'email': 'email address field',
        'tel': 'phone number field',
        'search': 'search field',
        'number': 'numeric field',
        'date': 'date field',
        'time': 'time field',
        'datetime-local': 'date and time field',
        'month': 'month field',
        'week': 'week field',
        'url': 'URL field',
        'textarea': 'text area field'
    };
    
    // Check in priority order
    if (input.placeholder.trim()) {
        ariaLabel = input.placeholder.trim();
    } else if (input.value.trim()) {
        ariaLabel = input.value.trim();
    } else if (input.name.trim()) {
        ariaLabel = input.name.trim();
    } else if (input.id.trim()) {
        // First check for associated label
        const labelElement = document.querySelector(`label[for="${input.id}"]`);
        if (labelElement && labelElement.textContent.trim()) {
            ariaLabel = labelElement.textContent.trim();
        } else {
            // Use type-specific label instead of ID
            ariaLabel = typeLabels[input.tagName.toLowerCase()] || typeLabels[input.type] || `${input.type || 'text'} input field`;
        }
    } else {
        // Default to type-specific label
        ariaLabel = typeLabels[input.tagName.toLowerCase()] || typeLabels[input.type] || `${input.type || 'text'} input field`;
    }
    
    input.setAttribute("aria-label", ariaLabel);
}

function addAriaLabelToLinkOrButton(element) {
    // Only skip if aria-label exists AND is not empty
    if (element.hasAttribute("aria-label") && element.getAttribute("aria-label").trim() !== "") {
        return;
    }
    
    const text = element.textContent.trim();
    if (text) {
        element.setAttribute("aria-label", text);
    }
}

// Start observing when DOM is ready
document.addEventListener("DOMContentLoaded", function() {
    try {
        // First handle existing elements
        document.querySelectorAll('input, textarea').forEach(addAriaLabel);
        document.querySelectorAll('a, button').forEach(addAriaLabelToLinkOrButton);
        
        // Then start observing for new elements
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    } catch (error) {
        console.error('Error initializing aria labels:', error);
    }
});
// End: Aria Label Automatic Accessibility Enhancement